import React from 'react'
import NavLink from '../Routes/NavLink'

import { search } from '../../core/controllers/Search'

export default class SearchBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            search: '',
            hidden: 'hidden',
            results: null
        }
        this.timeout =  0;

        this.hoveringResults = false;
    }

    componentDidMount() {
        var self = this;

        jQuery('.search-results-container').mouseover(function(e) {
            self.hoveringResults = true;
        });

        jQuery('.search-results-container').mouseleave(function(e) {
            self.hoveringResults = false;
        });

        jQuery('.search-bar').focusout(function(e) {
            if(!self.hoveringResults) {
                self.setState({
                    hidden: 'hidden'
                });
            }
        });
    }

    componentDidUpdate() {
        var self = this;
        if(this.state.hidden == '') {
            jQuery('#search-input').focus();
            jQuery('#search-input:text:visible:first').focus();
        }

        if(this.state.results != null && this.state.results.length > 0) {
            jQuery(jQuery('.search-results-container .scrollView')).slimScroll({
                height: '150px',
                alwaysVisible: true
            });
        }
    }

    componentWillUpdate(nextProps, nextState) {
    }

    toggleSearch() {
        var hidden = 'hidden';
        if(this.state.hidden == hidden) {
            hidden = '';
        }
        this.setState({
            hidden: hidden
        });
    }

    search(e) {
        var self = this;
        this.setState({
            search: e.target.value
        });

        var searchText = e.target.value;
        if(this.timeout) {
            clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
            if(searchText == '') {
                self.setState({
                    results: null
                });
                return;
            }
            search.find(searchText, function(response) {
                self.setState({
                    results: response.data
                });
            });
        }, 300);
    }

    render(){
        const hidden = this.state.hidden;
        const results = this.state.results;
        var searchHidden = 'hidden';
        var activeSearch = '';
        if(results) {
            searchHidden = '';
        }

        if(hidden == '') {
            activeSearch = 'active-search';
        } else {
            searchHidden = 'hidden';
        }
        return (
            <div class="search-bar">
                <i class={"fa fa-search " + activeSearch} onClick={this.toggleSearch.bind(this)}></i>
                <div class={"search-container " + hidden}>
                    <input id="search-input"  type="text" placeholder="Type in to search" value={this.state.search} onChange={this.search.bind(this)}/>
                </div>
                <div class={"search-results-container " + searchHidden}>
                <div class="scrollView">
                {results != null && results.length != 0 ? (
                    results.map(function(result, index){
                        return (
                            <div id="search-entry" class="row" key={index}>
                                <NavLink to={result.link}>
                                <div class="col-md-12">
                                    <div class="category">
                                        {result.category}
                                        <i class="pe-7s-angle-right"></i>
                                    </div>
                                    <div class="match-criteria">
                                    {result.match}
                                    </div>
                                </div>
                                </NavLink>
                            </div>
                        )
                    })
                ) : (
                    <p>No results found.</p>
                )}
                </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Search/SearchBar.jsx